<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Lorry Services table</h6>
        <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_date" class="form-control" v-model="search.datefrom">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_date" class="form-control" v-model="search.dateto">
            </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Services Type</label>
              <select class="form-control" v-model="search.type">
                  <option value="0">
                      All
                  </option>
                  <option v-for="(lorryservicestype,index) in this.lorryservicestype" :key="index" :value="lorryservicestype.id">
                      {{ lorryservicestype.service }}
                  </option>
              </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Vehicle No</label>
                <select class="form-control" v-model="search.vehicleno">
                  <option value="%">All</option>
                  <option v-for="(item,index) in vehicleList" :key="index" :value="item.vehicleno">
                      {{ item.vehicleno }}
                  </option>
              </select>
                <!-- <input class="form-control" v-model="search.vehicleno" id="input_vehicleno" type="text" placeholder="KCB8028" /> -->
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " style="float:right;" @click="getLorryServices">Search</button>
            </div>
        </div>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Lorry
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Service
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Location
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Remarks
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Service Date
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  
                </th>
                <!-- <th class="text-secondary opacity-7"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lorryservices,index) in paginatedLorryservices" :key="index">
                <td style="width:10%">
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ lorryservices.vehicleno }}</h6>
                    </div>
                  </div>
                </td>
                <td class="align-middle" style="width:20%">
                  <span class="text-xs font-weight-bold" >
                    {{ lorryservices.lorryservicestype }}<br />
                    RM {{ lorryservices.amount }}
                    </span>
                </td>
                <td class="align-middle" style="width:20%">
                  <span class="text-xs font-weight-bold" >
                    {{ lorryservices.location }}
                    </span>
                </td>
                <td class="align-middle" style="width:20%">
                  <span class="text-xs font-weight-bold" >
                    {{ lorryservices.reference }}<br />
                    {{ lorryservices.remark }}
                    </span>
                </td>
                <td class="align-middle" style="width:20%">
                  <span class="text-xs font-weight-bold" >
                    {{ lorryservices.servicedate }}<br />
                    Meter: {{ lorryservices.servicemeter }}
                    </span>
                </td>
                <td class="align-middle" style="width:10%">
                  <button class="btn btn-danger font-weight-bold text-xs" @click="removeLorryService(lorryservices.id)">Remove</button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from 'axios';

export default {
  name:'lorryServicesSelect',
  data(){
    return {
        totalRows: 0,
        currentPage: 0,
        perPage: 10,
        searchQuery:'',
        lorryservices: [],
        lorryservicestype:[],
        vehicleList:[],
        removeLorrySevices: {
          id:''
        },
        search:{
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          type: '',
          vehicleno: '%',
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.lorryservices.length / this.perPage);
    },
    paginatedLorryservices() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.lorryservices.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getLorryServices();
    this.getLorryServicesType();
    this.listAllVehicle();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getLorryServices(){
        var vm = this;
        var servicetype = vm.search.type;
        var vehicleno = vm.search.vehicleno;
        if(vehicleno == '')vehicleno = 'all';
        if(servicetype == '')servicetype = '0';
        axios.get('vehicle/listAllServices/' + vm.search.datefrom + '/' + 
        vm.search.dateto + '/' + servicetype + '/' + vehicleno)
            .then(res => {
                this.totalRows = res.data.lorryservices.length;
                this.currentPage = 1;
                this.lorryservices = res.data.lorryservices;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    getLorryServicesType(){
        // var mythis = this;
        axios.get('vehicle/listservicestype')
            .then(res => {
                this.lorryservicestype = res.data.lorryservicestype;
                this.search.type = '0';
                // console.log(this.model.lorryservicestype);
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    removeLorryService(id){
      if(confirm("Do you really want to remove this service records? ID - " + id)){
        this.removeLorrySevices.id = id;
        axios.post('vehicle/removeLorrySevices',this.removeLorrySevices)
            .then(res => {
                alert(res.data.message);
                this.removeLorrySevicesID = '';
                this.getLorryServices();
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: ID is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
      }
    },
    listAllVehicle(){
        axios.get('vehicle/listAllVehicle')
            .then(res => {
                this.vehicleList = res.data.vehicle;
                this.search.vehicleno = '%';
            }).catch(function (error){
                console.log('Error',error.message);
            });
    }
  },
}
</script>